export default __webpack_public_path__ + "static/media/logo.24cab5b4.svg";